import React, { useState } from 'react';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { Accordion, RadioButtons, Typography } from '@guildeducationinc/recess';
import { useHits, useMenu } from 'react-instantsearch-hooks-web';
import { weeklyEffortRanges } from 'src/clients/Algolia/constants';
import { trackClickedFilters, trackEvent } from 'src/services/analytics';
import { useSearchContext } from '@src/components/Providers/SearchProvider';
import { getDisabledValues, getTransformedItems } from '../filterHelpers';

export const WeeklyEffortFilter: React.FC = () => {
	const [toggleAccordion, setToggleAccordion] = useState<boolean>(false);
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const { results } = useHits();
	const { items, refine } = useMenu({
		attribute: 'weeklyEffortRange',
	});
	const { index } = useSearchContext();
	const transformedItems = getTransformedItems(items, weeklyEffortRanges);
	const selectedValue = items.find(item => item.isRefined)
		? items.find(item => item.isRefined).value
		: 'Any hours per week';

	const FilterTitle: React.FC = () => {
		const selectedFacetsCount = items.filter(
			facet => facet.isRefined && facet.value !== 'Any hours per week'
		).length;

		return (
			<Typography testid='weekly-effort-title' variant='h6'>{`Effort per week ${
				selectedFacetsCount > 0 ? `(${selectedFacetsCount})` : ''
			}`}</Typography>
		);
	};

	return (
		<Accordion
			defaultOpen={toggleAccordion}
			testid='WeeklyEffortFilterAccordion'
			title={FilterTitle}
		>
			<RadioButtons
				disabledValues={getDisabledValues(transformedItems)}
				groupLabel='Effort per week'
				hideGroupLabel
				name='Effort per week'
				onChange={e => {
					refine(e.target.value);
					setToggleAccordion(true);
					trackEvent('FilterAdded', {
						filterCategory: 'weeklyEffort',
						filterValue: [e.target.value],
					});
					trackClickedFilters({
						filters: [`weeklyEffort:${e.target.value}`],
						index,
						queryId: results.queryID,
						userUuid: user.id,
					});
				}}
				selectedValue={selectedValue}
				values={transformedItems}
			/>
		</Accordion>
	);
};
